export default __webpack_public_path__ + "static/media/notebook-icon.f3afe197.svg";